import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DTPicker = (props) => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (props.onDateChange) {
      props.onDateChange(date); // Call a callback function if provided
    }
  };

  return (
    <div>
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        showTimeSelect
        timeIntervals={15}
        dateFormat="yyyy-MM-dd HH:mm"
      />
    </div>
  );
};

export default DTPicker;
